import { APP_INITIALIZER, ErrorHandler, ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoggerService } from './services/logger/logger.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TrackingService } from './services/tracking/tracking.service';
import { AuthenticationService } from './services/authentication.service';
import { MessageBusService } from './services/message-bus/message-bus.service';
import { RouteNavigationService } from './routing/route-navigation.service';
import { ENVIRONMENT, WINDOW } from './services/injection-tokens';
import { environment } from '../../environments/environment';
import { CoolHttpModule } from '@angular-cool/http';
import { CoolStorageModule } from '@angular-cool/storage';
import { Angulartics2Module } from 'angulartics2';
import { StartupService, startupServiceFactory } from './services/startup/startup.service';
import { GlobalErrorHandler } from './services/logger/global-error-handler';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DateProvider } from './services/date.provider';
import { UnauthenticatedInterceptor } from './services/http/unauthenticated.interceptor';
import { LoggedInRouteGuardLogic } from './routing/route-guards/logged-in.guard';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { RedirectAfterService } from './routing/redirect-after.service';
import { FeaturePermissionsRouteGuardLogic } from './routing/route-guards/feature-permissions.guard';
import { LoggedInRegisterRouteGuardLogic } from './routing/route-guards/logged-in-register.guard';
import { MatButtonModule } from '@angular/material/button';
import { ServerSocketService } from './services/server-socket.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,

    FontAwesomeModule,

    CoolHttpModule,
    CoolStorageModule,

    MatButtonModule,
    MatProgressSpinnerModule,

    Angulartics2Module.forRoot(),
  ],
  exports: [
    CommonModule,

    CoolHttpModule,
    CoolStorageModule,

    Angulartics2Module,
  ],
})
export class AppCommonModule {
  public static forRoot(): ModuleWithProviders<AppCommonModule> {
    return {
      ngModule: AppCommonModule,
      providers: [
        LoggerService,
        TrackingService,
        RouteNavigationService,
        RedirectAfterService,
        AuthenticationService,
        ServerSocketService,

        MessageBusService,

        DateProvider,

        StartupService,
        UnauthenticatedInterceptor,

        LoggedInRouteGuardLogic,
        LoggedInRegisterRouteGuardLogic,
        FeaturePermissionsRouteGuardLogic,

        ...CoolHttpModule.forRoot().providers as Provider[],
        ...CoolStorageModule.forRoot().providers as Provider[],

        { provide: ENVIRONMENT, useValue: environment },
        { provide: WINDOW, useValue: window },
        { provide: ErrorHandler, useClass: environment.logging?.enabled ? GlobalErrorHandler : ErrorHandler },
        { provide: APP_INITIALIZER, useFactory: startupServiceFactory, deps: [StartupService], multi: true },
      ],
    };
  }
}
